import { Base } from './base';

export class Calculator extends Base {}

export * from './base';

export default { Calculator };
